module.exports = __webpack_public_path__ + "static/media/4.07569656.PNG";